import { useIntl } from 'react-intl'

import { isToday, isWithinInterval, isYesterday, subDays } from 'date-fns'

export const useGetRelativeDate = ({ includeTimeForAllDates = false }: { includeTimeForAllDates?: boolean } = {}) => {
  const intl = useIntl()
  const now = new Date()

  const getRelativeDate = (date: Date | null) => {
    let formatted
    if (!date) {
      formatted = 'empty'
    } else if (isToday(date)) {
      const todayDate = intl.formatDate(date, {
        hour: 'numeric',
        minute: 'numeric',
      })
      formatted = intl.formatMessage({ defaultMessage: 'Today, {todayDate}', description: 'Today' }, { todayDate })
    } else if (isYesterday(date)) {
      if (includeTimeForAllDates) {
        const yesterdayTime = intl.formatDate(date, { hour: 'numeric', minute: 'numeric' })
        formatted = intl.formatMessage(
          { defaultMessage: 'Yesterday, {yesterdayTime}', description: 'Yesterday with time' },
          { yesterdayTime },
        )
      } else {
        formatted = intl.formatMessage({ defaultMessage: 'Yesterday', description: 'Yesterday' })
      }
    } else if (isWithinInterval(date, { start: subDays(now, 7), end: now })) {
      if (includeTimeForAllDates) {
        formatted = intl.formatDate(date, { weekday: 'long', hour: 'numeric', minute: 'numeric' })
      } else {
        formatted = intl.formatDate(date, { weekday: 'long' })
      }
    } else if (includeTimeForAllDates) {
      formatted = intl.formatDate(date, {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      })
    } else {
      formatted = intl.formatDate(date, {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
      })
    }

    return formatted
  }

  return getRelativeDate
}
